let flashSaleSlider = new Swiper('.flash-sale__products.swiper', {
  slidesPerView: 2,
  loop: true,
  preventClicks:false,
  spaceBetween: 10,
  grabCursor: true,
  navigation: {
    prevEl: '.flash-sale__prev-button',
    nextEl: '.flash-sale__next-button'
  },
  breakpoints: {
    600: {
      slidesPerView: 4,
      spaceBetween: 40
    }
  }
})

let timerContainer = document.querySelectorAll('.flash__sale-time');
  if(timerContainer.length) {
    var countdownInterval = setInterval(countdown, 1000);
  }
  function countdown() {
    let now = new Date();
    let hours = 23 - now.getHours();
    let minutes = 59 - now.getMinutes();
    let seconds = 59 - now.getSeconds();
      
    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    let countdownTimer = '<span class="fdt-time fdt-time--hour">' + hours.toString() + "</span>" + ":" + '<span class="fdt-time fdt-time--minute">' + minutes.toString() + "</span>" + ":" + '<span class="fdt-time fdt-time--second">' + seconds.toString() + "</span>";

    document.querySelectorAll(".flash__sale-time").forEach((item) => {
      item.innerHTML = countdownTimer;
    })
      
    if (hours == 0 && minutes == 0 && seconds == 0) {
      clearInterval(countdownInterval);
      countdown();
    }
  }